import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {KompenzacijaDocument} from "./KompenzacijaDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: osnov kompenzacije, lista priloga

export const kompenzacijaDocumentFields: IntercateKeysMap<KompenzacijaDocument, EntityField<KompenzacijaDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	ground: {
		name: "ground", dataType: EntityFieldDataType._string, label: "Tip ugovora",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<KompenzacijaDocument>> = [
	kompenzacijaDocumentFields.indexingNumber,
	kompenzacijaDocumentFields.indexingDate,
	kompenzacijaDocumentFields.documentNumber,
	kompenzacijaDocumentFields.documentDate,
	kompenzacijaDocumentFields.assignedTo,
	kompenzacijaDocumentFields.clientId,
	kompenzacijaDocumentFields.sectorId,
	kompenzacijaDocumentFields.ground,
	kompenzacijaDocumentFields.tags,
	kompenzacijaDocumentFields.description,
	kompenzacijaDocumentFields.parentId
]

export const kompenzacijaDocumentFieldsDescriptor: EntityFieldsDescriptor<KompenzacijaDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
